import { createContext } from 'react';

export const errorContext = createContext({
  errorText: '',
  setErrorText: () => {}
});
